import React from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import CustomPageTable from "./CustomPage.Table";
import CustomPageModal from "./Modal/CustomPage.modal";

const CustomPage = ({
  t,
  columns,
  data,
  useCreate,
  useRefresh,
  useFilter,
  onCreateClick,
  onFilterHandle,
  onRefreshHandle,
  onSubmit,
  isEdit,
  modal,
  pageSize,
  pageName,
  onCloseModal,
  getTrProps,
  loading,
  classTable,
  flexiableDefaultColsWidth,
  isExportCSV,
  setIsExportCSV,
  tableStyle,
  children,
  useCusomCol,
  modalCreateTitle,
  modalEditTitle,
  isSubmitting,
  cardBodyStyle = {},
  paginationText,
  isSmallSize,
  formRef,
  lstDisabled
}) => {
  return (
    <Row>
      <Col md={12} style={{ padding: 0 }}>
        <Card>
          <CardBody style={{ paddingBottom: '10px', ...cardBodyStyle}}>
            {children}
            <Row style={{ marginTop: 8 }}>
              <Col md={12}>
                <CustomPageTable
                  data={data}
                  columns={columns}
                  pageSize={pageSize}
                  useCreate={useCreate}
                  useFilter={useFilter}
                  useRefresh={useRefresh}
                  onCreateClick={onCreateClick}
                  onFilterHandle={onFilterHandle}
                  onRefreshHandle={onRefreshHandle}
                  getTrProps={getTrProps}
                  loading={loading}
                  classTable={classTable}
                  flexiableDefaultColsWidth={flexiableDefaultColsWidth}
                  isExportCSV={isExportCSV}
                  setIsExportCSV={setIsExportCSV}
                  pageName={pageName}
                  style={tableStyle}
                  useCusomCol={useCusomCol}
                  paginationText={paginationText}
                  isSmallSize={isSmallSize}
                />
              </Col>
            </Row>
          </CardBody>
        </Card>
        <CustomPageModal
          modal={modal}
          isEdit={isEdit}
          onSubmit={onSubmit}
          pageName={pageName}
          onCloseModal={onCloseModal}
          dataModal={columns}
          createTitle={modalCreateTitle}
          editTitle={modalEditTitle}
          isSubmitting={isSubmitting}
          formRef={formRef}
          lstDisabled={lstDisabled}
        />
      </Col>
    </Row>
  );
};
export default CustomPage;
